import { AlertHistoricalProps } from './props';
import { useAlertHistorical } from './hook';
import { Table } from '../../../../components/general/table';
import { useState } from 'react';

export const AlertHistorical = (
    historical: AlertHistoricalProps,
    showHistorical?: AlertHistoricalProps
) => {
    const { columns, rows } = useAlertHistorical(historical);
    const [paginationModel, setPaginationModel] = useState({
        page: 0,
        pageSize: 10,
    });

    const handlePaginationChange = (newPagination: {
        page: number;
        pageSize: number;
    }) => {
        setPaginationModel(newPagination);
    };

    const paginatedRows = rows.slice(
        paginationModel.page * paginationModel.pageSize,
        (paginationModel.page + 1) * paginationModel.pageSize
    );

    if (!showHistorical) {
        return null;
    }

    return (
        <Table
            columns={columns}
            rows={paginatedRows}
            rowCount={rows.length}
            paginationModel={paginationModel}
            onPaginationModelChange={handlePaginationChange}
            pageSizeOptions={[10, 20, 50]}
            disableRowSelectionOnClick
        />
    );
};
